import React from "react";
import { Helmet } from "react-helmet";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Container from "@material-ui/core/Container";
import { endOfTitle } from "../../../constants/constants";
import "../../program/pages/style.css";
import FilterResults from "../components/schoolStudent/FilterResults";
import { SchoolStudentsPageProvider } from "../context/schoolStudentsPageContext";
import Filter from "../components/schoolStudent/Filter";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
    columnGap: 24,
  },
  filterContainer: {
    position: "relative",
  },
}));

export const SchoolStudentsPage = () => {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>Students{endOfTitle}</title>
      </Helmet>
      <SchoolStudentsPageProvider>
        <Container maxWidth="lg" className={classes.root}>
          <div className={classes.filterContainer}>
            <Filter />
          </div>
          <FilterResults />
        </Container>
      </SchoolStudentsPageProvider>
    </>
  );
};
